import { render, staticRenderFns } from "./WinnersOverlay.vue?vue&type=template&id=76b55d54&"
import script from "./WinnersOverlay.vue?vue&type=script&lang=js&"
export * from "./WinnersOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports